module.exports = __webpack_public_path__ + "static/media/contact.90c44d6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/images/contact.jpg
// module id = 238
// module chunks = 27